import ResourceSelect from "../../../../../../../../components/shared/inputs/ResourceSelect";
import { getSettingsOrgResourceSearchFilters } from "../../../../../../../../utils/helpers/settings";
import { useFilterResourceParams } from "../../../../../hooks/filters/useFilterResourceParams";
import { useOrgSettingsResourceLabel } from "../../../../../../../../utils/hooks/useOrgSettingsResourceLabel";

type LevelSelectProps = {
    value?: any;
    onChange?: (value: any) => void;
    group: string;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    allowClear?: boolean;
    filterName?: string;
};

function LevelSelect({ value, onChange, group, placeholder, disabled, className, allowClear, filterName }: LevelSelectProps) {
    const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();
    const filterParams = useFilterResourceParams(filterName);

    return (
        <ResourceSelect
            mode="single"
            value={value}
            onChange={onChange}
            className={className}
            disabled={disabled}
            allowClear={allowClear}
            placeholder={placeholder}
            resourcePath={`/${group}/org-levels`}
            renderLabel={renderOrgLevelResourceLabel}
            getSearchFilter={getSettingsOrgResourceSearchFilters}
            params={filterParams}
        />
    );
}

export default LevelSelect;
